export const SET_ROLES_DATA = 'SET_ROLES_DATA';
export const SET_ROLE_DATA = 'SET_ROLE_DATA';
export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const SET_USER_SESSION_DATA = 'SET_USER_SESSION_DATA';
export const SET_PERIMETER_DATA = 'SET_PERIMETER_DATA';
export const LOGOUT = 'LOGOUT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_INFO_STATE = 'SET_USER_INFO_STATE';
export const SET_SESSION_INFO = 'SET_SESSION_INFO';
